import detail from './detail';

class TemplateLearCard {
    name = 'templateLearCard';
    constructor() {
        this.detail = detail;
    }
}
export default new TemplateLearCard();
